// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The static preloader in public/index.html has done its job once React
// has taken over — AuthContext's own loading state handles everything
// from here.
document.getElementById("initial-loader")?.remove();
